/* eslint-disable no-console */
/* eslint-disable no-undef */

import data from '../constants/gtm_data_events';

export const DataLayerMixin = {
  methods: {
    asuoDataLayerClick: function (page, id, overrideAttr, additionalAttr) {
      let attr = { ...data[page][id] };

      // lowercase and apply override
      if (overrideAttr)
        Object.keys(overrideAttr).forEach(
          (e) =>
            (attr[e] = typeof overrideAttr[e] === 'string' ? (overrideAttr[e] || '').toLowerCase() : overrideAttr[e])
        );
      if (additionalAttr)
        Object.keys(additionalAttr).forEach(
          (e) =>
            (attr[e] =
              typeof additionalAttr[e] === 'string' ? (additionalAttr[e] || '').toLowerCase() : additionalAttr[e])
        );

      // push to data layer
      if (typeof dataLayer !== 'undefined') {
        dataLayer.push(attr);
        // Enable below for logging non-ecommerce events
        // console.log('[GTM Event] Pushing to dataLayer:', JSON.stringify(attr, null, 2));
      } else {
        console.error('[GTM Event] dataLayer is not defined!');
      }
    }
  }
};
